import each from 'lodash/each'
import find from 'lodash/find'
import {STATUSES} from "@/components/statuses";
import errorCatcher from '@/modules/BackendErrorCatcher';
import Raven from 'raven-js';

import {BLOCKS_CONFIG, SEND_CONFIG} from '@/storage/config/profileConfig';

const UNEMPLOYMENT_TYPES = [
    'PENSIONER',
    'STUDENT',
    'HOUSEWIFE',
    'UNEMPLOYED'
];

export default {
    methods: {
        combineProfileObject: function (fieldsBlock) {
            let _this = this;
            let data = new URLSearchParams();


            each(fieldsBlock, function (item, key) {
                let object = find(BLOCKS_CONFIG, ['name', item]);
                each(object.fields, function (field, key) {
                    // Если поле в имени содержит слово phone чистим его от маски
                    if (field.toLowerCase().indexOf('phone') > -1) {
                        data.append(SEND_CONFIG[field], _this[field].replace(/[^0-9.]/g, ""));
                    } else {
                        switch (field) {
                            case 'secondName': {
                                if (_this.middleNameUpsent) {
                                    data.append('middleNameUpsent', true);
                                    data.append(SEND_CONFIG[field], '');
                                } else {
                                    data.append(SEND_CONFIG[field], _this[field]);
                                }
                                break;
                            }
                            case 'registrationState': {
                                data.append(SEND_CONFIG[field] + 'Id', parseInt(_this[field], 10));
                                data.append(SEND_CONFIG[field], find(_this.registrationStateList, {'value': parseInt(_this[field], 10)}).label);
                                break;
                            }
                            case 'registrationDistrict': {
                                if (_this[field] === '') {
                                    data.append(SEND_CONFIG[field] + 'Id', '');
                                    data.append(SEND_CONFIG[field], '');
                                } else {
                                    data.append(SEND_CONFIG[field] + 'Id', parseInt(_this[field], 10));
                                    data.append(SEND_CONFIG[field], find(_this.registrationDistrictList, {'value': parseInt(_this[field], 10)}).label);
                                }
                                break;
                            }
                            case 'registrationCity': {
                                if (_this[field] === '') {
                                    data.append(SEND_CONFIG[field] + 'Id', '');
                                    data.append(SEND_CONFIG[field], '');
                                } else {
                                    data.append(SEND_CONFIG[field] + 'Id', parseInt(_this[field], 10));
                                    data.append(SEND_CONFIG[field], find(_this.registrationCityList, {'value': parseInt(_this[field], 10)}).label);
                                }
                                break;
                            }
                            case 'homeState': {
                                data.append(SEND_CONFIG[field] + 'Id', parseInt(_this[field], 10));
                                data.append(SEND_CONFIG[field], find(_this.homeStateList, {'value': parseInt(_this[field], 10)}).label);
                                break;
                            }
                            case 'homeDistrict': {
                                if (_this[field] === '') {
                                    data.append(SEND_CONFIG[field] + 'Id', '');
                                    data.append(SEND_CONFIG[field], '');
                                } else {
                                    data.append(SEND_CONFIG[field] + 'Id', parseInt(_this[field], 10));
                                    data.append(SEND_CONFIG[field], find(_this.homeDistrictList, {'value': parseInt(_this[field], 10)}).label);
                                }
                                break;
                            }
                            case 'homeCity': {
                                if (_this[field] === '') {
                                    data.append(SEND_CONFIG[field] + 'Id', '');
                                    data.append(SEND_CONFIG[field], '');
                                } else {
                                    data.append(SEND_CONFIG[field] + 'Id', parseInt(_this[field], 10));
                                    data.append(SEND_CONFIG[field], find(_this.homeCityList, {'value': parseInt(_this[field], 10)}).label);
                                }
                                break;
                            }
                            case 'additionalIncome': {
                                data.append(SEND_CONFIG[field], parseInt(_this[field].replace(/[^0-9.]/g, ""), 10));
                                break;
                            }

                            default: {
                                data.append(SEND_CONFIG[field], _this[field]);
                                break;
                            }
                        }
                    }
                });
            });

            return data;
        },

        save: function (fieldsBlock) {
            let _this = this;
            let data = this.combineProfileObject(fieldsBlock);

            this.$http.post('/json/profile', data, {}).then(
                response => {
                    switch (response.data.code) {
                        case 0: {
                            _this.$validator.errors.clear();
                            each(fieldsBlock, function (blockItem, blockKey) {
                                let fieldsObject = find(BLOCKS_CONFIG, ['name', blockItem]);
                                each(fieldsObject.fields, function (item, key) {
                                    _this[item + 'ExternalStatus'] = STATUSES.COMPLETE;
                                });
                            });

                            each(fieldsBlock, function (item, key) {
                                let object = find(BLOCKS_CONFIG, ['name', item]);
                                object.confirmed = true;
                            });

                            break;
                        }
                        case 100: {
                            each(response.data.validationErrors, function (item, key) {
                                let field = _this.$validator.fields.find({name: errorCatcher.parseConfig(key) });
                                _this.$validator.errors.add(
                                   errorCatcher.parseConfig(key),
                                   errorCatcher.getErrorMessage(item)
                                );
                            });
                            break;
                        }
                    }
                    Raven.captureMessage('Step end: '+_this.$options.name, {
                        level: 'info'
                    });
                },
            ).catch(response => {

            });
        },

        isCompleteBlock: function(name){
            return find(BLOCKS_CONFIG, ['name', name]).confirmed;
        },

        selectWorkType: function(){
            let BLOCK = find(BLOCKS_CONFIG, {name: 'workInfo'});
            BLOCK.confirmed = UNEMPLOYMENT_TYPES.indexOf(this.workType) > -1;
        },
    },
    beforeCreate(){
        if( !this.$store.getters['profile/isInited'] ){
            this.$store.dispatch('profile/INIT');
        }
    },
    mounted(){

    }
}